import * as React from 'react';
import Typography from '@mui/material/Typography';
import ExtendCard from '../components/ExtendCard';

const InfoPage = () => {
    return (
        <span>
            <ExtendCard 
                panelimage=""
                datestring="2022/04/17"
                title="RSSリーダー？">
                <Typography variant="body2" color="text.secondary">
                    RSSリーダー作ってみたものの、<br />
                    書くこと自体は簡単だったけど、知識不足でアプリクラッシュ連発。<br />
                    （エミュではしっかり動くけど、実機インストールで動かすと落ちる）<br />
                    こういうのがでると、なかなか突破できない、、、<br />
                    デバッグというか、なんというか、<br />
                    iOSアプリの開発はWindows環境ではやはり不利なのかなぁ<br />
                </Typography>
            </ExtendCard>
            <br />
            <ExtendCard 
                panelimage="../img/contemplative-reptile_512.jpg"
                datestring="2022/03/09"
                title="3月9日">
                <Typography variant="body2" color="text.secondary">
                    ウェブページ開設<br />
                    現状、どうしても必要となったため作成。<br />
                    何年振りだろう、、、、<br />
                </Typography>
            </ExtendCard>
            <br />
            <ExtendCard 
                panelimage="../img/coffee_512.jpg"
                datestring="2022/03/09"
                title="copi-memo">
                <Typography variant="body2" color="text.secondary">
                    複雑な操作をなくして、できる限りシンプルな操作にした、<br />
                    コピペツールです。<br /><br />
                    <div style={{alignItems:'center',justifyContent: 'center'}}>
                    <a href="https://apple.co/3LaRZ6v" 
                        target="_blank" 
                        rel="noopener noreferrer">
                    <img alt="app store" style={{height:60}} 
                    src="../img/badge/Download_on_the_App_Store_Badge_JP_RGB_blk_100317.svg" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.ryofuna.copimemoslug" 
                        target="_blank" 
                        rel="noopener noreferrer">
                        <img alt="google play" style={{height:80}} src="../img/badge/google-play-badge.png" />
                    </a>
                    </div>
                </Typography>
            </ExtendCard>
            <br />
            <ExtendCard 
                panelimage="../img/pexels-daria-liudnaya-7354593_512.jpg"
                datestring="2022/03/09"
                title="copi-memo privacy policy">
                <Typography variant="body2" color="text.secondary">
                <a
                    className="App-link"
                    href="./copimemo/privacypolicy/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    copi-memo privacy policy
                </a>
                </Typography>
            </ExtendCard>
            <br />
            <br />
        </span>
    )
}

export default InfoPage